import { Component, Input, OnDestroy, OnInit  } from '@angular/core';
import { Subscription } from 'rxjs';

import { IDataset } from '../../models/dataset';
import { PlotsService } from '../../services/plots.service';


export interface IEventElement {
    time: number;
    event: any;
}

/** Component for setting filters on the plot data */
@Component({
    selector: 'sci-text-viewer',
    templateUrl: './text-viewer.component.html',
    styleUrls: [ './text-viewer.component.scss' ]
})
export class TextViewerComponent implements OnInit, OnDestroy {
    @Input() dataset: IDataset;
    @Input() plotId: string;
    eventsList: IEventElement[];
    displayedColumns = [ 'time', 'event' ];
    subscriptions: Subscription[] = [];
    hoveredEvent: IEventElement;

    constructor( private _plotService: PlotsService ) {}

    ngOnInit() {
        const timeFormat = 'YYYY-MM-DD';
        this.eventsList = this.dataset.data.map( event => {
            return {
                time: event[0],
                event: event[1]
            };
        });

        this.subscriptions.push( this._plotService.xPosition$.subscribe( response => {
            if ( response && response.position && this.eventsList ) {
                this.hoveredEvent = this.getNearestEvent( response.position );
            }
        }));
    }

    ngOnDestroy() {
        this.subscriptions.forEach( subscription => subscription.unsubscribe() );
    }

    getNearestEvent( x: number ): IEventElement {
        return this.eventsList.reduce( ( prev, curr ) => Math.abs( curr.time - x ) < Math.abs( prev.time - x ) ? curr : prev );
    }

    hoverEvent( event: IEventElement ) {
        this._plotService.setXPosition( event.time, this.plotId );
    }
}
